import type { ClientPushCategoryUserSetting } from '@DigitaleDoerfer/digitale-doerfer-api';

export const PushCategorySection = {
  Posts: 'posts',
  Groups: 'groups',
  Miscellaneous: 'miscellaneous'
} as const;

export type PushCategorySection =
  (typeof PushCategorySection)[keyof typeof PushCategorySection];

export type PushCategory = {
  key: PushCategorySection;
  values?: ClientPushCategoryUserSetting[];
};
